import './LangSwitcher.css'

import { useTranslation } from 'react-i18next'

import LangIcon from '@/assets/icons/lang-icon.svg?react'

export const LangSwitcher = () => {
  const { i18n } = useTranslation()
  const currentLang = i18n.language

  const toggleLanguage = (lang: string) => {
    i18n.changeLanguage(lang)
  }

  return (
    <div className="lang-switcher">
      <LangIcon className="mr-2" />
      <button
        type="button"
        className={`lang-switcher__option ${currentLang.includes('sv') || !currentLang.includes('en') ? 'lang-switcher__option--active' : ''}`}
        onClick={() => toggleLanguage('sv')}
        aria-label="Switch to Swedish"
      >
        SE
      </button>
      <button
        type="button"
        className={`lang-switcher__option ${currentLang.includes('en') ? 'lang-switcher__option--active' : ''}`}
        onClick={() => toggleLanguage('en')}
        aria-label="Switch to English"
      >
        EN
      </button>
    </div>
  )
}
